import { privateInstance } from "../configs";

export const integratedTransactionApi = {
  async getIntegratedTransactions(params) {
    let req = "/inventory/api/integrated-transaction/";

    if (params) {
      req += "?";
      let params_array = [];
      if (params.uncompleted !== undefined)
        params_array.push(`uncompleted=${params.uncompleted}`);
      if (params.deleted !== undefined)
        params_array.push(`deleted=${params.deleted}`);
      req += params_array.join("&");
    }

    const res = await privateInstance.get(req);
    return res.data;
  },
  async updateIntegratedTransaction(id, transaction) {
    const res = await privateInstance.patch(
      `/inventory/api/integrated-transaction/${id}/`,
      transaction
    );
    return res.data;
  },
  async sendReport(file) {
    const res = await privateInstance.post(
      `/inventory/api/report/send/`,
      file,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );
    return res.data;
  },
  async getIntegratedInventoryTransactionReports() {
    const res = await privateInstance.get(
      `/inventory/api/integrated-transaction-report/`
    );
    return res.data;
  },
  async getLastIntegratedInventoryTransactionReport() {
    const res = await privateInstance.get(
      `/inventory/api/integrated-transaction-report/?last=true`
    );
    if (res.data.length > 0) {
      return res.data[0];
    } else {
      return undefined;
    }
  },
  async updateCostFromTransactions(data) {
    const res = await privateInstance.post(
      `inventory/api/integrated-transaction/cost/update/`,
      data
    );
    return res.data;
  }
};
